import React from "react";
import Carousel from "@/bit/components/components.carousel";
import DeviceCardFake from "./device-card-fake";

const CrossSellingFake = () => {
  const items = [1, 2, 3, 4];

  return (
    <>
      <div className="cross-selling-fake">
        <div className="skeleton cross-selling-fake--title" />
        <div className="skeleton cross-selling-fake--subtitle" />
        <Carousel slideSeparation={16}>
          {items.map((item) => (
            <div key={item}>
              <DeviceCardFake />
            </div>
          ))}
        </Carousel>
        <div className="skeleton cross-selling-fake--button" />
      </div>
      <style jsx>{`
        .cross-selling-fake {
          display: flex;
          flex-direction: column;
          gap: 1rem;
          &--title {
            width: 50%;
            height: 20px;
          }
          &--subtitle {
            width: 90%;
            height: 18px;
          }
          &--button {
            width: 33%;
            height: 32px;
          }
        }
      `}</style>
    </>
  );
};

export default CrossSellingFake;
